import type { RepositoryFile } from './types';

const encoder = new TextEncoder();

export const repositoryFileBytes = (file: Pick<RepositoryFile, 'content' | 'mimeType'>) => {
  if (file.content === undefined) throw new Error('File content is not loaded');
  const prefix = `data:${file.mimeType};base64,`;
  if (!file.content.startsWith(prefix)) return encoder.encode(file.content);
  const binary = atob(file.content.slice(prefix.length));
  return Uint8Array.from(binary, (character) => character.charCodeAt(0));
};
